export const TOAST_MESSAGES_DELETE_SPACE_MEMBER = {
  DELETE_SPACE_MEMBER_ERROR: 'Error delete space member, please try again',
  DELETE_SPACE_MEMBER_SUCCESS: 'Space member deleted successfully!',
};

export const BANNER_TITLE = 'Please double-check before deleting. This action is permanent.';

export const DESCRIPTION = 'Do you want to delete this people?';
